module.exports = __webpack_public_path__ + "img/coin-CCF.fe524cb9.svg";